export const inputSmall = () => ({
    width: 260,
    maxWidth: '100%',
});
